// extracted by mini-css-extract-plugin
export default {"collabs":"ArtistCollabsContainer-module_collabs__CP6zk"};